var names = [
    "signal",
    "raise",
    "pipe",
    "dup",
    "dup2",
    "dup3",
    "execv",
    "execl",
    "execvp",
    "execlp",
    "getpwnam",
    "getpwnam_r",
    "getpwent",
    "tcsetpgrp",
    "kill",
    "killpg",
    "fork",
    "realpath",
    "getpid",
    "getpgid",
    "setpgid",
    "getpgrp",
    "setpgrp",
    "issetugid",
    "strsignal",
    "wait4",
    "waitpid",
    "getuid",
    "geteuid",
    "getgid",
    "getegid",
    "getsid",
    "setegid",
    "seteuid",
    "setgid",
    "setuid",
    "setsid",
    "umask",
    "getrlimit",
    "setrlimit",
    "getpriority",
    "setpriority",
    "sigfillset",
    "sigprocmask",
    "sigsetmask",
    "siginterrupt",
    "sigaltstack",
    "sigwait",
    "sigpending",
    "getppid",
    "tcgetpgrp",
    "gethostname",
    "tzset",
    "flockfile",
    "ftrylockfile",
    "funlockfile",
    "getpwuid",
    "getpwuid_r",
    "setpwent",
    "endpwent",
    "getgrgid",
    "setreuid",
    "setregid",
    "strmode",
    "acl_get_file",
    "acl_free",
    "acl_get_entry",
    "fchdir",
    "chown",
    "fchown",
    "lchown",
    "fchownat",
    "chmod",
    "fchmod",
    "fchmodat",
    "lchmod",
    "chflags",
    "fchflags",
    "lchflags",
    "chroot",
    "getgroups",
    "utimes",
    "futimes",
    "lutimes",
    "clock_gettime",
    "clock_settime",
    "alarm",
    "system",
    "mkfifo",
    "mkstemp",
    "mkstemps",
    "mkostemp",
    "mkostemps",
    "tmpfile",
    "settimeofday",
    "bsd_signal",
    "ttyname",
    "ttyname_r",
    "ctermid_r",
    "socket",
    "connect",
    "popen",
    "pclose",
    "sync",
    "nice",
    "errx",        //???
    "vwarnx",      //???
    // posix
    "posix_spawn",
    "posix_spawnp",
    "posix_spawnattr_init",
    "posix_spawnattr_destroy",
    "posix_spawnattr_setflags",
    "posix_spawnattr_setsigmask",
    "posix_spawn_file_actions_init",
    "posix_spawn_file_actions_destroy",
    "posix_spawn_file_actions_addopen",
    "posix_spawn_file_actions_addclose",
    "posix_spawn_file_actions_adddup2",
    // pthreads
    "pthread_mutex_init",
    "pthread_mutex_lock",
    "pthread_cond_timedwait",
    "pthread_cond_signal",
    "pthread_mutex_unlock",
    "pthread_cond_destroy",
    "pthread_mutex_destroy", 
    "pthread_cond_wait",
    "pthread_cond_init",
    "pthread_attr_init",
    "pthread_attr_setstacksize",
    "pthread_attr_destroy",
    "pthread_create",
    "pthread_detach",
    "pthread_self",
    "pthread_kill",
    "pthread_exit",
    "pthread_mutex_trylock",
    "pthread_key_create",
    "pthread_key_delete",
    "pthread_setspecific",
    "pthread_getspecific",
    "pthread_sigmask",
    "pthread_attr_getscope",
    "pthread_attr_setscope",
    "posix_spawnattr_setpgroup",
    "posix_spawnattr_setsigdefault",
    // curses (terminfo)
    "tgetent",
    "tgetflag",
    "tgetnum",
    "tgetstr",
    "tgoto",
    "tputs",
    // termios
    "cfgetospeed",
    "cfgetispeed",
    "cfsetospeed",
    "cfsetispeed",
    "tcsendbreak",
    "tcdrain",
    "tcflush",
    "tcflow",
    "tcgetsid",
    // util (tty)
    "login",
    "login_tty",
    "logout",
    "logwtmp",
    "opendev",
    "openpty",
    "fparseln",
    "forkpty",
    "pidlock",
    "ttylock",
    "ttyunlock",
    "ttyaction",
    "ttymsg",
]

const stubs: {
    debug: (message: string) => void,
    [key: string]: (...args: any[]) => void
} = {
    debug: (message) => {}
};
for (let nm of names) {
    stubs[nm] = function() {
        stubs.debug(`stub for ${nm} [${[...arguments]}]`);
    }
}

export default stubs
